"use client";
import { jsx as l } from "react/jsx-runtime";
import { memo as a } from "react";
import e from "../components/Icon/SvgIcon.js";
const m = (o) => /* @__PURE__ */ l(
  e,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2.217 5.217c.54-.54 1.27-.842 2.033-.842h15a2.875 2.875 0 0 1 2.875 2.875v10.5a2.875 2.875 0 0 1-2.875 2.875h-15a2.875 2.875 0 0 1-2.875-2.875V7.25c0-.763.303-1.494.842-2.033m.408 2.033v.244a1.63 1.63 0 0 0 .773 1.384l7.5 4.614a1.63 1.63 0 0 0 1.704 0l7.5-4.615a1.63 1.63 0 0 0 .773-1.384V7.25a1.625 1.625 0 0 0-1.625-1.625h-15A1.625 1.625 0 0 0 2.625 7.25m18.25 2.615-.117.076-4.806 2.959 4.923 3.408zm-.002 7.961-6.084-4.212-1.531.942a2.88 2.88 0 0 1-3.015 0l-1.532-.942-6.084 4.212a1.625 1.625 0 0 0 1.623 1.549h15a1.625 1.625 0 0 0 1.623-1.549M2.625 16.307 7.548 12.9 2.743 9.942q-.06-.037-.118-.076z",
        clipRule: "evenodd"
      }
    )
  }
), h = a(m);
export {
  h as Mail,
  h as default
};
